import axios from "axios";
import { parseDate } from "@helpers/utils";
import { installLocationReservationsMock } from "@/mocks/locationReservationsMock";

export const BASE_API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000';
console.log("🚀 ~ BASE_API_URL:", BASE_API_URL)

const caxios = axios.create({
  baseURL: BASE_API_URL+"/api/"
});

// Dev-only: `npm run dev:location-reservations` fakes the `enable_location_reservations` company setting
// until the backend returns it (BACK-739). `import.meta.env.DEV` is statically false in a production
// build, so the branch and the module behind it are dropped at bundle time.
if (import.meta.env.DEV && import.meta.env.VITE_MOCK_LOCATION_RESERVATIONS === "true") {
  installLocationReservationsMock(caxios);
}


declare module 'axios' {
  interface AxiosRequestConfig {
    parseDates?: string[];
  }
}

caxios.interceptors.response.use(originalResponse => {
  originalResponse.config.parseDates?.forEach(field => {
    parseDate(originalResponse.data.payload, field);
  })


  return originalResponse;
})

export default caxios;
